import React, { useState } from "react";
import { Menu, Dropdown, List, Row, Col, Popover } from "antd";
import { NavLink, useParams } from "react-router-dom";

import "./index.css";

const settingMenu = (
  <Menu style={{ width: "200px" }} aria-label="Options">
    <Menu.Item key="1">
      <p>
        <i className="fa-solid fa-share-nodes"></i> Share
      </p>
    </Menu.Item>
    <Menu.Item key="2">
      <p>
        <i className="fa-regular fa-pen-to-square "></i> Rename
      </p>
    </Menu.Item>
    <Menu.Item key="3">
      <p>
        <i className="fa-solid fa-arrow-right"></i> Move
      </p>
    </Menu.Item>
    <Menu.Item key="4">
      <i className="fa-solid fa-folder-plus"></i> New Folder
    </Menu.Item>
    <Menu.Item key="5">
      <i className="fa-regular fa-eye-slash"></i> Show Archived
    </Menu.Item>
    <Menu.Item key="6">
      <p style={{ color: "red" }}>
        <i className="fa-regular fa-trash-can"></i> Delete
      </p>
    </Menu.Item>
  </Menu>
);

const menu = (
  <Menu
    style={{ width: "200px", height: "300px", overflow: "scroll" }}
    aria-label="Options"
  >
    <Menu.Item key="1">
      <p>
        <i className="fa-solid fa-play"></i> Run Workflow
      </p>
    </Menu.Item>
    <Menu.Item key="2">
      <p>
        <i className="fa-regular fa-pen-to-square "></i> Edit
      </p>
    </Menu.Item>
    <Menu.Item key="3">
      <p>
        <i className="fa-solid fa-share"></i> Share
      </p>
    </Menu.Item>
    <Menu.Item key="4">
      <i className="fa-solid fa-table-list"></i> View Workflow runs
    </Menu.Item>
    <Menu.Item key="5">
      <i className="fa-solid fa-link"></i> Copy Share Link
    </Menu.Item>
    <Menu.Item key="6">
      <p>
        <i className="fa-solid fa-play"></i> Workflow run link
      </p>
    </Menu.Item>
    <Menu.Item key="7">
      <p>
        <i className="fa-solid fa-forward"></i> Run multiple
      </p>
    </Menu.Item>
    <Menu.Item key="8">
      <p>
        <i className="fa-regular fa-clock"></i> Scheduled workFlow
      </p>
    </Menu.Item>
    <Menu.Item key="9">
      <p>
        <i className="fa-solid fa-clock-rotate-left"></i> Activity
      </p>
    </Menu.Item>
    <Menu.Item key="10">
      <p>
        <i className="fa-regular fa-eye"></i> Subscribe
      </p>
    </Menu.Item>
    <Menu.Item key="11">
      <p>
        <i className="fa-solid fa-tag"></i> Manage tags
      </p>
    </Menu.Item>
    <Menu.Item key="12">
      <p>
        <i className="fa-solid fa-share"></i> Add to public library
      </p>
    </Menu.Item>
    <Menu.Item key="13">
      <p>
        <i className="fa-solid fa-arrow-right"></i> Move
      </p>
    </Menu.Item>
    <Menu.Item key="14">
      <p>
        <i className="fa-solid fa-copy"></i> Duplicate
      </p>
    </Menu.Item>
    <Menu.Item key="15">
      <p>
        <i className="fa-solid fa-download"></i> Export
      </p>
    </Menu.Item>
    <Menu.Item key="16">
      <p>
        <i className="fa-solid fa-print"></i> Print
      </p>
    </Menu.Item>
    <Menu.Item key="17">
      <p>
        <i className="fa-solid fa-box-archive"></i> Archive
      </p>
    </Menu.Item>
    <Menu.Item key="18">
      <p style={{ color: "red" }}>
        <i className="fa-regular fa-trash-can"></i> Delete
      </p>
    </Menu.Item>
  </Menu>
);

const item = [
  {
    itemCategory: "folder",
    itemType: "Property Management Processes",
    icon: "fa-sharp fa-solid fa-truck",
    workNumber: 29,
    title: "A. Move Out",
    color: "#687980",
  },
  {
    itemType: "Property Management Processes",
    icon: "fa-sharp fa-solid fa-screwdriver-wrench",
    workNumber: 37,
    title: "B. Make Ready",
    color: "#687980",
  },
  {
    itemType: "Property Management Processes",
    icon: "fa-solid fa-mobile-retro",
    workNumber: 2,
    title: "C. SD refund",
    color: "#687980",
  },
  {
    itemType: "Property Management Processes",
    icon: "fa-solid fa-house-chimney-crack",
    workNumber: 0,
    title: "D. Property Listing",
    color: "#687980",
  },
  {
    itemType: "Property Management Processes",
    icon: "fa-solid fa-pen-nib",
    workNumber: 0,
    title: "E. Bi-Weekly Listing follow up",
    color: "#645CBB",
  },
  {
    itemType: "Admin Tasks",
    icon: "fa-solid fa-folder",
    workNumber: 122,
    title: "Gerson Tasks",
    color: "#645CBB",
  },

  {
    itemType: "Admin Tasks",
    icon: "fa-solid fa-folder",
    workNumber: 122,
    title: "Rhett Tasks",
    color: "#645CBB",
  },
  {
    itemType: "Admin Tasks",
    icon: "fa-solid fa-folder",
    workNumber: 122,
    title: "Teresa Tasks",
    color: "#645CBB",
  },
  {
    itemType: "Support Staff",
    icon: "fa-solid fa-folder",
    workNumber: 122,
    title: "Field Staff",
    color: "#645CBB",
  },
  {
    itemType: "Office Staff",
    icon: "fa-solid fa-folder",
    workNumber: 122,
    title: "Field Staff",
    color: "#645CBB",
  },
  {
    itemType: "Scheduled communications",
    icon: "fa-regular fa-envelope",
    workNumber: 122,
    title: "Monthly Tenant update from property manager",
    color: "#645CBB",
  },
];
const titleMatch = "Property Management Processes";

const LibraryPropertyItemPage = () => {
  const [listData, setListData] = useState(item);
  const { category } = useParams();
  const content = (
    <Row className="popover-container">
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "flow"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-brands fa-nfc-symbol"
              style={{ color: "#645CBB" }}
            ></i>
          </Col>
          <Col>
            <strong>Workflow</strong>
            <p className="silver-text">Build a new workflow</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "flow"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-brands fa-nfc-symbol"
              style={{ color: "#645CBB" }}
            ></i>
          </Col>
          <Col>
            <strong>Workflow from Template</strong>
            <p className="silver-text">Explore our Template Gallery</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "page"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-solid fa-file-lines"
              style={{ color: "#3b921e" }}
            ></i>
          </Col>
          <Col>
            <strong>Page</strong>
            <p className="silver-text">Document Team Knowledge</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "folder"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i className="fa-solid fa-folder" style={{ color: "#687980" }}></i>
          </Col>
          <Col>
            <strong>Folder</strong>
            <p className="silver-text">Organize Workflows and Pages</p>
          </Col>
        </Row>
      </Col>
    </Row>
  );

  let key;

  const CreateNewItem = (key) => {
    if (key === "folder") {
      setListData([
        ...listData,
        {
          itemCategory: "folder",
          itemType: category,
          icon: "fa-solid fa-folder",
          title: "untitled",
          color: "#687980",
        },
      ]);
    }
    if (key === "flow") {
      setListData([
        ...listData,
        {
          itemCategory: "flow",
          itemType: category,
          icon: "fa-brands fa-nfc-symbol",
          title: "untitled",
          color: "#645CBB",
        },
      ]);
    }
    if (key === "page") {
      setListData([
        ...listData,
        {
          itemCategory: "flow",
          itemType: category,
          icon: "fa-solid fa-file-lines",
          title: "untitled",
          color: "#3b921e",
        },
      ]);
    }
  };

  return (
    <div className="task-property LibraryPropertyItemPages">
      <p className="right-title">
        <span>Library / {category}</span>
        <i className="fa-solid fa-mobile-retro"></i>

        <Dropdown overlay={settingMenu} trigger={["click"]}>
          <i className="fa-solid fa-gear"></i>
        </Dropdown>
      </p>

      <List
        className="demo-loadmore-list"
        itemLayout="horizontal"
        dataSource={listData}
        renderItem={(item) =>
          item.itemType === category ? (
            <List.Item
              actions={[
                <Dropdown overlay={menu} trigger={["click"]}>
                  <i className={"fa-solid fa-ellipsis"}></i>
                </Dropdown>,
                <i
                  className={
                    item.icon === "users"
                      ? "fa-solid fa-users"
                      : "fa-solid fa-building"
                  }
                ></i>,
                <i key="viewA" className="fa-solid fa-chart-bar"></i>,
                <i key="viewWF" className="fa-solid fa-table-list parent-work">
                  {item.workNumber > 0 ? (
                    <span className="child-work-number">{item.workNumber}</span>
                  ) : null}
                </i>,
              ]}
            >
              <Row gutter={[24, 0]} className="folder-title" align="middle">
                <Col>
                  <i
                    className={item.icon}
                    style={{
                      fontSize: "18px",
                      color: item.color,
                    }}
                  ></i>
                </Col>
                {/* <NavLink to={`/tasks/library/Viewing/${item.title}`}> */}
                  <Col>
                    <span style={{ fontSize: "17px" }}>{item.title}</span>
                  </Col>
                {/* </NavLink> */}
              </Row>
            </List.Item>
          ) : null
        }
      />
      <Popover
        placement="topLeft"
        title="Create"
        content={content}
        trigger="click"
      >
        <Row gutter={[16, 0]} className="add-new">
          <Col>
            <i className="fa-solid fa-plus"></i>
          </Col>
          <Col>
            <span>New</span>
          </Col>
        </Row>
      </Popover>
    </div>
  );
};
export default LibraryPropertyItemPage;
